import { css, html, LitElement } from 'lit-element';
import { pxToRem } from 'lm-ui-kit/src/utils/css-utils';
import { desktop } from '../utils';

const paymentSystems = [
  {
    name: 'mir',
    alt: 'Мир',
    src:
      '//cdn.leroymerlin.ru/lmru/image/upload/v1/other/navigation-microfronts/header-footer/mir-logo.svg/file.svg',
  },
  {
    name: 'visa',
    alt: 'Visa',
    src:
      '//cdn.leroymerlin.ru/lmru/image/upload/v1/other/navigation-microfronts/header-footer/visa-logo.svg/file.svg',
  },
  {
    name: 'mastercard',
    alt: 'Mastercard',
    src:
      '//cdn.leroymerlin.ru/lmru/image/upload/v1/other/navigation-microfronts/header-footer/mastercard-logo.svg/file.svg',
  },
];

export class UcPaymentSystems extends LitElement {
  static get styles() {
    return css`
      :host {
        display: flex;
        flex-wrap: wrap;
        height: 100%;

        align-items: center;

        font-size: ${pxToRem(10)};
      }

      .title {
        margin-right: ${pxToRem(16)};
      }

      .payment-systems-wrap {
        display: flex;
        flex: 1 0 auto;
        align-items: center;
        justify-content: space-between;
      }

      .payment-system {
        width: auto;
        height: auto;
      }

      .payment-system.mir {
        height: ${pxToRem(14)};
      }

      .payment-system.visa {
        height: ${pxToRem(16)};
      }

      .payment-system.mastercard {
        height: ${pxToRem(23)};
      }

      ${desktop(css`
        :host {
          font-size: ${pxToRem(14)};
        }

        .payment-system.mir {
          height: ${pxToRem(16)};
        }

        .payment-system.visa {
          height: ${pxToRem(19)};
        }

        .payment-system.mastercard {
          height: ${pxToRem(27)};
        }
      `)}
    `;
  }

  render() {
    return html`
      <span class="title">Мы принимаем: </span>

      <div class="payment-systems-wrap">
        ${paymentSystems.map(
          ({ name, alt, src }) => html`
            <img
              width="49"
              height="14"
              class="payment-system ${name}"
              alt=${alt}
              src=${src}
              loading="lazy"
            />
          `
        )}
      </div>
    `;
  }
}
